import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3 1 1.5 5v15H7v3h3l3-3h4l5.5-5.5V1zm2 2h15.5v10.5L17 17h-5l-2.5 2.5V17H5zm5 9.5V7h2v5.5zM15 7v5.5h2V7z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandVideoTwitch = { render };
export {
  brandVideoTwitch as default,
  render
};
//# sourceMappingURL=brand-video-twitch.svg.js.map
